export const formatPrice = ({ price, currency = 'CZK' }: { price: number; currency?: string }) => {
  return Intl.NumberFormat('cs-CZ', {
    style: 'currency',
    maximumFractionDigits: 0,
    currency: currency,
  }).format(price)
}
